"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckExistingTVAssociatedResponseMapper = void 0;
var CheckExistingTVAssociatedResponseMapper = /** @class */ (function () {
    function CheckExistingTVAssociatedResponseMapper(data) {
        this.localData = data;
    }
    CheckExistingTVAssociatedResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CheckExistingTVAssociatedResponseMapper;
}());
exports.CheckExistingTVAssociatedResponseMapper = CheckExistingTVAssociatedResponseMapper;
//# sourceMappingURL=CheckExistingTVAssociatedResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CheckExistingTVAssociatedResponseMapper.js
// module id = 1967
// module chunks = 8